module.exports = __webpack_public_path__ + "img/jk-2.7ea14b86.jpg";